import { Box } from '@mui/material';
import * as React from 'react';
import LoadingBackdrop from '../../Common/LoadingBackdrop';
import EmptyLayout from '../../Components/EmptyLayout';
import { useGenerateTokenMutation } from '../../generated/auth/graphql-react-query';
import { useCookieContext, useUserInfo } from '../Hooks/useUserInfo';
import { AmplifyContext, AmplifyContextProps } from './AmplifyContext';

interface AmplifyContextProviderProps extends AmplifyContextProps {
  children: React.ReactNode;
}

export default function AmplifyContextProvider(props: AmplifyContextProviderProps) {
  const { children, signOut, user } = props;
  const { token, setToken, removeToken } = useCookieContext();
  const mutation = useGenerateTokenMutation({
    onSuccess(data) {
      setToken(data.generateToken);
    },
    onError(error) {
      console.error('Error generating token', error);
    },
  });

  React.useEffect(() => {
    mutation.mutate({});
  }, []);

  const userInfo = useUserInfo(token);

  React.useEffect(() => {
    if (userInfo.isSuccess && !userInfo.isError && userInfo.data === undefined) {
      removeToken();
    }
  }, [userInfo.isSuccess, !userInfo.isError, userInfo.data === undefined]);

  const value = React.useMemo(() => ({ signOut, user }), [signOut, user]);
  return (
    <AmplifyContext.Provider value={value}>
      {userInfo.data ? children : <EmptyLayout><Box className="content"><LoadingBackdrop /></Box></EmptyLayout>}
    </AmplifyContext.Provider>
  );
}
